import constants from '../../constants/app-constants';

export const  updateOnBoardingStatus = (status) => {
  return{
    type: constants.user.ONBOARDING_UPDATE_STATUS ,
    payload: status
  };
};